import React from 'react'
import BankForm from '../../components/Fundraiser/BankForm';

const AddBank = () => {
  return (
    <BankForm />
  )
}

export default AddBank;